@if (isMobile()) {
  <div class="flex flex-col gap-2">
    @if (users()?.length > 0) {
      @for (user of users(); track user?.id) {
        <div class="flex w-full gap-4 border-default items-center bg-proffeo-surface p-4 transition-default">
          <div
            class="bg-proffeo-action-primary flex h-10 min-h-10 w-10 min-w-10 items-center justify-center rounded-full"
          >
            <p class="text-lg uppercase text-proffeo-on-action">
              {{ user?.firstName.at(0) + user?.lastName.at(0) }}
            </p>
          </div>
          <div class="flex w-full justify-between overflow-hidden">
            <div class="flex w-full flex-col gap-1">
              <div class="flex w-full items-center justify-between">
                <p class="truncate">{{ user?.fullName }}</p>
                <mat-icon
                  [matMenuTriggerFor]="matUserMenu"
                  fontIcon="more_vert"
                  class="cursor-pointer"
                />
                <mat-menu #matUserMenu>
                  <div class="flex h-full w-full flex-col">
                    <div
                      (click)="openEditUserDialog(user)"
                      class="flex w-full items-center gap-1 px-4 py-2"
                    >
                      <mat-icon
                        fontIcon="edit"
                        class="icon-md"
                      />
                      <p>{{ 'users-list-actions-menu-edit-user' | translate }}</p>
                    </div>
                    @if (user?.status === UserStatus.LOCKED) {
                      <div
                        (click)="onUnlockUser(user)"
                        class="flex w-full items-center gap-1 px-4 py-2"
                      >
                        <mat-icon
                          fontIcon="lock_open"
                          class="icon-md"
                        />
                        <p>{{ 'users-list-actions-menu-unlock-user' | translate }}</p>
                      </div>
                    } @else {
                      <div
                        (click)="onLockUser(user)"
                        class="flex w-full items-center gap-1 px-4 py-2"
                      >
                        <mat-icon
                          fontIcon="lock"
                          class="icon-md"
                        />
                        <p>{{ 'users-list-actions-menu-lock-user' | translate }}</p>
                      </div>
                    }
                    <div
                      (click)="openUserDeleteConfirmationDialog(user)"
                      class="flex w-full items-center gap-1 px-4 py-2"
                    >
                      <mat-icon
                        fontIcon="delete"
                        class="icon-md"
                      />
                      <p>{{ 'users-list-actions-menu-delete-user' | translate }}</p>
                    </div>
                    @if (user?.status === UserStatus.INACTIVE) {
                      <div
                        (click)="onResendActivationLink(user)"
                        class="flex w-full items-center gap-1 px-4 py-2"
                      >
                        <mat-icon
                          fontIcon="mail"
                          class="icon-md"
                        />
                        <p>{{ 'users-list-actions-menu-resend-activation-link' | translate }}</p>
                      </div>
                    }
                  </div>
                </mat-menu>
              </div>
              <div class="flex w-full flex-col gap-1">
                <div class="flex w-full gap-1">
                  <div class="flex-shrink min-w-1/2 truncate items-center gap-1">
                    <mat-icon
                      fontIcon="alternate_email"
                      class="icon-md"
                    />
                    <a
                      [href]="'mailto:' + $safeNavigationMigration(user?.email)"
                      class="text-sm truncate"
                    >
                      {{ user?.email }}
                    </a>
                  </div>
                  @if (user?.phoneNumbers) {
                    <div class="flex min-w-0 flex-shrink-0 items-center gap-1">
                      <mat-icon
                        fontIcon="phone"
                        class="icon-md"
                      />
                      <a
                        [href]="'tel:' + $safeNavigationMigration(user?.phoneNumbers)"
                        class="text-sm truncate"
                      >
                        {{ user?.phoneNumbers }}
                      </a>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="flex w-full items-center justify-center p-4">
        <p>{{ 'placeholders.no-results-found' | translate }}</p>
      </div>
    }
  </div>
} @else {
  <ng-template
    #emailCell
    let-user
  >
    <a
      [href]="'mailto:' + user.email"
      class="block truncate text-sm"
    >
      {{ user.email }}
    </a>
  </ng-template>

  <ng-template
    #phoneCell
    let-user
  >
    @if (user.phoneNumbers) {
      <a
        [href]="'tel:' + user.phoneNumbers"
        class="block truncate text-sm"
      >
        {{ user.phoneNumbers }}
      </a>
    }
  </ng-template>

  <ng-template
    #statusCell
    let-user
  >
    <proffeo-user-status
      [userStatus]="user.status"
      class="w-full text-sm"
    />
  </ng-template>

  <ng-template
    #createdAtCell
    let-user
  >
    <span class="text-sm">{{ user.createdAt | proffeoDate }}</span>
  </ng-template>

  <ng-template
    #profileCompletionCell
    let-user
  >
    <span class="text-sm">{{ user.profileCompletion }}%</span>
  </ng-template>

  <ng-template
    #actionsCell
    let-user
  >
    <button
      (click)="stopRowActivation($event)"
      [matMenuTriggerFor]="matUserMenu"
      [attr.aria-label]="'users-list-actions-menu-show-details' | translate"
      type="button"
      class="inline-flex cursor-pointer items-center justify-center"
    >
      <mat-icon fontIcon="more_vert" />
    </button>
    <mat-menu #matUserMenu>
      <button
        (click)="openEditUserDialog(user)"
        type="button"
        mat-menu-item
      >
        <mat-icon fontIcon="edit" />
        <span>{{ 'users-list-actions-menu-edit-user' | translate }}</span>
      </button>
      @if (user.status === UserStatus.LOCKED) {
        <button
          (click)="onUnlockUser(user)"
          type="button"
          mat-menu-item
        >
          <mat-icon fontIcon="lock_open" />
          <span>{{ 'users-list-actions-menu-unlock-user' | translate }}</span>
        </button>
      } @else {
        <button
          (click)="onLockUser(user)"
          type="button"
          mat-menu-item
        >
          <mat-icon fontIcon="lock" />
          <span>{{ 'users-list-actions-menu-lock-user' | translate }}</span>
        </button>
      }
      <button
        (click)="openUserDeleteConfirmationDialog(user)"
        type="button"
        mat-menu-item
      >
        <mat-icon fontIcon="delete" />
        <span>{{ 'users-list-actions-menu-delete-user' | translate }}</span>
      </button>
      @if (user.status === UserStatus.INACTIVE) {
        <button
          (click)="onResendActivationLink(user)"
          type="button"
          mat-menu-item
        >
          <mat-icon fontIcon="mail" />
          <span>{{ 'users-list-actions-menu-resend-activation-link' | translate }}</span>
        </button>
      }
    </mat-menu>
  </ng-template>

  <proffeo-ui-table
    [columns]="columns()"
    [emptyText]="'placeholders.no-results-found' | translate"
    [rowId]="resolveRowId"
    [rows]="users()"
    [tableAriaLabel]="'users-list-desktop-view-users-list' | translate"
    orderMode="none"
    class="w-full"
  />
}
